<template lang="pug">
  .routine-handler-wrapper
    RadioSlider.slider(v-if="!disabled" :items="modes" :current="currentMode" @selected="changeMode",
      :disabledModes="!this.state.routine ? ['calendar'] : []")

      template(v-slot="{ tab }")
        div {{ tab.name }}

    Validate(v-model="state.initialDay" :minDate="admission")
      PDatePicker(:disabled="disabled" :label="`data inicial da ${$ws('routine')}`" required name="initialDay" :minDate="admission")

    Transition(name="fade")
      label(style="grid-column: 3/6; align-self: baseline;" v-if="currentMode === 1")
        span(style="color: var(--color-primary); font-weight: 590;") escala selecionada:
        span  {{selectedRoutine.item.name}}

    template(v-if="!disabled")
      Transition(name="fade" v-if="state.initialDay")
        label(style="grid-column: 1/6; align-self: center; text-align: center" v-if="currentMode === 1")
          | selecione a {{ $ws('journey') }} correspondente ao primeiro dia da {{ $ws('routine') }} do empregado

      Transition(name="fade" v-if="!state.initialDay")
        label.box(style="grid-column: 1/6; align-self: center; text-align: center" v-if="currentMode === 1")
          | para ver o calendário, selecione a data inicial da {{$ws('routine')}}

    .expand
      TransitionExpand
        template(v-if="currentMode === 1 && journeysPhase && state.initialDay")
          .journeys(v-if="!disabled && formatedJourneys" key="jrnselect")
            PButton(v-for="(jrn, index) in formatedJourneys" :disabled="index === state.phaseShift"
            :color="jrn.color" size="md" :key="jrn.id" block @click="changePhase(index)")
              | {{ jrn.text }}

          Calendar.calendar(dayFormat="DD.MM", :startDate="state.initialDay", :endDate="endDate" key="calendar")

            template(v-slot:header="{ index, daysNames}")
              span.fs-19(:class="index >= 6 ? 'color-danger' : 'color-primary'")
                | {{ daysNames[index] }}

            template(v-slot="{ date, dateIndex }")
              span.day
                span {{ date.date | date }}

                span.fs-15(:class="{[`background-${journeysPhase[dateIndex].color}`]: true}")
                  | {{ journeysPhase[dateIndex].text }}

        RoutinePicker(v-model="selectedRoutine" v-show="currentMode === 0" key="routine-picker" @selected="selected")

</template>

<script>
import RoutinePicker from 'src/common/RoutinePicker'
import Calendar from 'src/common/date/Calendar'
import moment from 'moment'
import { rightJourneyTextAndColor, rangeDates } from 'src/utils'
import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'
import { mapState } from 'vuex'

export default {
  name: 'RoutineHandler',
  components: {RoutinePicker, Calendar},
  props: {
    disabled: Boolean
  },
  mixins: [handlerUseStateVmodel(true)],
  data () {
    return {
      mode: 'routine',
      internalSelectedRoutine: {
        index: null,
        selected: null
      }
    }
  },
  watch: {
    routineInfo (newValue) {
      if (newValue.routine) {
        this.internalSelectedRoutine = {
          selected: newValue,
          index: this.$store.state.common.routines.items.findIndex(i => i.id === newValue.routine.id)
        }
        this.changeMode({id: 'calendar'})
      }
    }
  },
  computed: {
    ...mapState('employee/details', ['routineInfo', 'admission']),
    selectedRoutine: {
      set (value) {
        this.state = {
          ...this.state,
          routine: value.selected
        }
        this.internalSelectedRoutine = value
      },
      get () {
        return {
          item: this.routineInfo.routine,
          selected: this.internalSelectedRoutine.index
        }
      }
    },
    modes () {
      return [
        {name: this.$ws('routine'), id: 'routine'},
        {name: 'calendário', id: 'calendar'}
      ]
    },
    currentMode () {
      return this.modes.findIndex(i => i.id === this.mode)
    },
    endDate () {
      if (!this.state.routine) { return null }

      return moment(this.state.initialDay)
        .add(Math.max(7, Math.ceil(this.state.routine.journeys.length * 1.5)), 'days')
        .toDate()
    },
    formatedJourneys () {
      if (!this.state.routine) { return null }

      return this.state.routine.journeys
        .map(journey => {
          return {text: rightJourneyTextAndColor(journey).text, color: journey.color}
        })
    },
    journeysPhase () {
      if (!this.state.routine || !this.formatedJourneys) { return null }

      return rangeDates(this.state.initialDay, this.endDate)
        .map((i, index) => this.formatedJourneys[(this.state.phaseShift + index) % this.formatedJourneys.length])
    }
  },
  methods: {
    changeMode (mode) {
      this.mode = mode.id
    },
    changePhase (phaseShift) {
      this.state = {...this.state, phaseShift}
    },
    selected () {
      this.changeMode({id: 'calendar'})
    }
  },
  filters: {
    date (date) {
      return moment(date).format('DD/MM')
    }
  }
}
</script>

<style scoped lang="scss">
.routine-handler-wrapper {
  align-items: baseline;

  .slider {
    height: fit-content;
    align-self: baseline;
  }

  .expand {
    grid-column: 1/6;
    padding: 20px 0 0px 0;
  }

  .journeys {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 10px;
    padding-bottom: 20px;
  }

  .calendar {
    border: 1px solid var(--color-primary);
    padding: 10px;
    span.day {
      display: grid;
      grid-template-rows: 1fr 3fr;
      height: 50px;
      align-items: center;
      justify-items: center;
      padding: 5px 0;

      span:first-child {
        font-weight: bold;
        color: var(--color-primary);
      }
      span:last-child {
        width: 80%;
        text-align: center;
        transition: all 0.1s linear;
      }
    }
  }

  .box{
    border: 1px solid var(--color-primary);
    margin-top: 30px;
    padding: 10px 0;
  }
}
</style>
